import { render, staticRenderFns } from "./add_complate.vue?vue&type=template&id=a20c8ed4&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a20c8ed4')) {
      api.createRecord('a20c8ed4', component.options)
    } else {
      api.reload('a20c8ed4', component.options)
    }
    module.hot.accept("./add_complate.vue?vue&type=template&id=a20c8ed4&lang=pug&", function () {
      api.rerender('a20c8ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payment/add_complate.vue"
export default component.exports